import { setTerm } from './helpers';
import { TJsonQuery } from './types';
import { toESortValue, TSortKey } from '../../shared/common/utils/sort/sortMapping';

const setSortTerm = setTerm('sort');

export const setSort =
  (jsonQuery: TJsonQuery) =>
  (sortKey: null | TSortKey): TJsonQuery =>
    setSortTerm(jsonQuery)(sortKey ? toESortValue(sortKey) : null);
